import React from 'react'

// ---------------------------------------------------------------------------
// Icon registry – do not edit manually.
// Add SVG files to src/components/icons/svgs/ and run `yarn generate-icons`.
// ---------------------------------------------------------------------------
interface ISvgIconDef {
  d: string | ReadonlyArray<string>
  viewBox: string
  strokeWidth?: number
}

// <generated-icon-registry>
const ICON_REGISTRY = {
  'Arrows/chevron-down': {
    d: 'M6 9L12 15L18 9',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Arrows/chevron-left': {
    d: 'M15 18L9 12L15 6',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Arrows/chevron-right': {
    d: 'M9 18L15 12L9 6',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Arrows/chevron-up': {
    d: 'M18 15L12 9L6 15',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Files/file-02': {
    d: 'M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'General/building-04': {
    d: 'M9.5 7H14.5M9.5 11H14.5M9.5 15H14.5M18 21V6.2C18 5.0799 18 4.51984 17.782 4.09202C17.5903 3.71569 17.2843 3.40973 16.908 3.21799C16.4802 3 15.9201 3 14.8 3H9.2C8.0799 3 7.51984 3 7.09202 3.21799C6.71569 3.40973 6.40973 3.71569 6.21799 4.09202C6 4.51984 6 5.0799 6 6.2V21M20 21H4',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'General/check': {
    d: 'M20 6L9 17L4 12',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'General/download-03': {
    d: 'M8 12L12 16M12 16L16 12M12 16V8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'General/edit-05': {
    d: 'M11 4.00001H6.8C5.11984 4.00001 4.27976 4.00001 3.63803 4.32699C3.07354 4.61461 2.6146 5.07356 2.32698 5.63804C2 6.27978 2 7.11986 2 8.80001V17.2C2 18.8802 2 19.7203 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7203 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9448C10.8425 15.8958 11.0376 15.815 11.2166 15.7053C11.4184 15.5816 11.5914 15.4087 11.9373 15.0628L21.5 5.50001C22.3284 4.67159 22.3284 3.32844 21.5 2.50001C20.6716 1.67159 19.3284 1.67159 18.5 2.50001L8.93723 12.0628C8.59133 12.4087 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3616C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'General/x': {
    d: 'M17 7L7 17M7 7L17 17',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Security/lock-01': {
    d: 'M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Share/email': {
    d: [
      'M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10',
      'M3 7l9 6l9 -6'
    ],
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Share/facebook': {
    d: 'M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Share/link': {
    d: [
      'M9 15l6 -6',
      'M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464',
      'M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463'
    ],
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Share/linkedin': {
    d: [
      'M8 11v5',
      'M8 8v.01',
      'M12 16v-5',
      'M16 16v-3a2 2 0 1 0 -4 0',
      'M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10'
    ],
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Share/whatsapp': {
    d: [
      'M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9',
      'M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1'
    ],
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Users/user-01': {
    d: 'M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Users/user-plus-01': {
    d: 'M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Users/user-square': {
    d: 'M4.00002 21.8174C4.6026 22 5.41649 22 6.8 22H17.2C18.5835 22 19.3974 22 20 21.8174M4.00002 21.8174C3.87082 21.7783 3.75133 21.7308 3.63803 21.673C3.07354 21.3854 2.6146 20.9265 2.32698 20.362C2 19.7202 2 18.8802 2 17.2V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V17.2C22 18.8802 22 19.7202 21.673 20.362C21.3854 20.9265 20.9265 21.3854 20.362 21.673C20.2487 21.7308 20.1292 21.7783 20 21.8174M4.00002 21.8174C4.00035 21.0081 4.00521 20.5799 4.07686 20.2196C4.39249 18.6329 5.63288 17.3925 7.21964 17.0769C7.60603 17 8.07069 17 9 17H15C15.9293 17 16.394 17 16.7804 17.0769C18.3671 17.3925 19.6075 18.6329 19.9231 20.2196C19.9948 20.5799 19.9996 21.0081 20 21.8174M16 9.5C16 11.7091 14.2091 13.5 12 13.5C9.79086 13.5 8 11.7091 8 9.5C8 7.29086 9.79086 5.5 12 5.5C14.2091 5.5 16 7.29086 16 9.5Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  },
  'Users/users-03': {
    d: 'M18 15.8369C19.4559 16.5683 20.7041 17.742 21.6152 19.2096C21.7956 19.5003 21.8858 19.6456 21.917 19.8468C21.9804 20.2558 21.7008 20.7585 21.3199 20.9204C21.1325 21 20.9216 21 20.5 21M16 11.5322C17.4817 10.7959 18.5 9.26686 18.5 7.5C18.5 5.73314 17.4817 4.20411 16 3.46776M14 7.5C14 9.98528 11.9852 12 9.49996 12C7.01468 12 4.99996 9.98528 4.99996 7.5C4.99996 5.01472 7.01468 3 9.49996 3C11.9852 3 14 5.01472 14 7.5ZM2.55919 18.9383C4.1535 16.5446 6.66933 15 9.49996 15C12.3306 15 14.8464 16.5446 16.4407 18.9383C16.79 19.4628 16.9646 19.725 16.9445 20.0599C16.9289 20.3207 16.7579 20.64 16.5495 20.7976C16.2819 21 15.9138 21 15.1776 21H3.82232C3.08613 21 2.71804 21 2.4504 20.7976C2.24201 20.64 2.07105 20.3207 2.05539 20.0599C2.03529 19.725 2.20992 19.4628 2.55919 18.9383Z',
    viewBox: '0 0 24 24',
    strokeWidth: 2
  }
} as const satisfies Record<string, ISvgIconDef>
// </generated-icon-registry>

export type SvgIconName = keyof typeof ICON_REGISTRY
export const SVG_ICON_NAMES = Object.keys(ICON_REGISTRY) as SvgIconName[]

// ---------------------------------------------------------------------------

export interface IProps {
  name: SvgIconName
  size?: number
  color?: string
  gradient?: boolean
  className?: string
}

// Matches $gradient-horizontal: linear-gradient(270deg, $color-primary 0%, $color-primary-2 100%)
// 270deg = right → left, so x1="100%" x2="0%"
const GRADIENT_COLOR_START = 'var(--action-gradient-start, #49B675)'
const GRADIENT_COLOR_END = 'var(--action-gradient-end, #6EDA6C)'
const GRADIENT_ID_PREFIX = 'svg-icon-gradient'

export const SvgIcon: React.FC<IProps> = ({ name, size = 24, color, gradient, className }) => {
  const gradientId = gradient ? `${GRADIENT_ID_PREFIX}-${name}` : undefined

  const paintValue = gradientId ? `url(#${gradientId})` : (color ?? 'currentColor')

  const { d, viewBox, strokeWidth = 2 }: ISvgIconDef = ICON_REGISTRY[name]
  const paths = typeof d === 'string' ? [d] : d

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={className}
    >
      {gradientId && (
        <defs>
          <linearGradient id={gradientId} x1="100%" y1="0%" x2="0%" y2="0%">
            <stop offset="0%" stopColor={GRADIENT_COLOR_START} />
            <stop offset="100%" stopColor={GRADIENT_COLOR_END} />
          </linearGradient>
        </defs>
      )}
      {paths.map((pathD, i) => (
        <path
          key={i}
          d={pathD}
          stroke={paintValue}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  )
}
